export function isNullOrUndefined(value) {
    return value === null || value === undefined;
}
export function isString(value) {
    return typeof value === "string";
}
export function isNumber(value) {
    return typeof value === "number";
}
//# sourceMappingURL=utils.js.map